<template>
  <div class="detail-page">
    <!-- <van-nav-bar
      ref="nav"
      :border="false"
      @click-left="back"
      placeholder
      :fixed="true"
      :title="name || '课程详情'"
    >
      <template #left>
        <van-icon size="20px" name="arrow-left" color="#333" />
      </template>
</van-nav-bar> -->
    <van-popup v-model="show" position="bottom">
      <div class="share-box">
        <div @click="toShare">
          <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share3.png" alt="" />
          微信
        </div>
        <div @click="copy">
          <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share2.png" alt="" />
          复制链接
        </div>
      </div>
    </van-popup>
    <div class="share-wrap" @click="show2 = false" v-show="show2">
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share1.png" alt="" />
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share4.png" alt="" />
    </div>
    <div class="video-wrap">
      <div class="coverImg" v-if="!playId">
        <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2限免，1不限免-->
        <!-- <div class="tip">
          
          <img :src="$free" v-if="is_free==2"/>
          <img :src="$vip" v-else-if="is_vip==1"/>
          <img :src="$noVip" v-else>
        </div> -->
        <van-image class="price-cover" fit="cover" :error-icon="$placeImg" :loading-icon="$placeImg"
          :src="baseInfo.cover" alt=""></van-image>
      </div>
      <van-icon size="20px" class="back" v-if="!isTrain" @click="back" name="arrow-left" color="#ddd" />
      <div class="video" id="video" v-if="playId"></div>
      <!-- <div class="share" @click="show = true" v-if="plat != 120">
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share_icon.png"
        />
        分享
      </div> -->
    </div>
    <van-tabs swipe-threshold="4" @change="changeTab" color="#000000" title-inactive-color="#999999"
      title-active-colo="#000" line-width="16" v-model="active" class="tab myTabs">
      <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2限免，1不限免-->
      <van-tab title-class="tab-class" title="课程详情" v-if="baseInfo.content_app">
        <div class="tab-content" :class="{
          tabContentBottom: (is_vip && !vipInfo.is_buy) || !baseInfo.is_buy,
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <div class="lesson-img html-view" v-html="baseInfo.content_app"></div>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" :title="baseInfo.category_id != '226' ? '视频课程' : '课程列表'"
        v-if="lessonList && lessonList.length || down_list && down_list.length">
        <div class="tab-content" :style="{
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <lessonList :baseInfo="baseInfo" @playVideo="playVideo2" @updata="getData" :down_list="down_list"
            :list="lessonList" :discipline_id="baseInfo.discipline_id" :isBuy="baseInfo.is_buy"
            :price="parseFloat(baseInfo.price)" :name="baseInfo.name" :goods_course_id="baseInfo.goods_course_id">
          </lessonList>
        </div>

      </van-tab>
      <van-tab title-class="tab-class" title="课程讲义" v-if="handouts.length">
        <div class="tab-content" :style="{
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <img :src="item.cover" v-for="(item, index) in handouts" :key="index" />
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="思维导图" v-if="map.length">
        <div class="tab-content" :style="{
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <img :src="item.cover" v-for="(item, index) in map" :key="index" />
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="示范课程" v-if="demonstrate.length">
        <div class="tab-content" :style="{
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <exampleList :list="demonstrate" :isBuy="baseInfo.is_buy"></exampleList>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="课程考试" v-if="examinList.length">
        <div class="tab-content" :style="{
          background: '#f0f2f5',
          paddingTop: '20px',
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">

          <div class="examinTitle" v-if="id != 774"><span></span>
            <p>理论课程考试</p><span></span>
          </div>
          <detailExamin :baseInfo="baseInfo" :testInfo="{ ...item }" v-for="(item, index) in examinList" :key="index">
          </detailExamin>

          <div class="examinTitle" style="padding-top: 20px" v-if="examinList2.length">
            <span></span>
            <p>实操课程考核</p>
            <span></span>
          </div>
          <detailVideo :testInfo="{ ...item, discipline_id: baseInfo.discipline_id }" v-for="item in examinList2"
            :key="item.id" @updata="getData"></detailVideo>
        </div>
      </van-tab>

      <van-tab title-class="tab-class" title="纸质书籍" v-if="paper_book.length">
        <div class="tab-content" :style="{
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <div v-for="(item, index) in paper_book" :key="index">
            <img :src="item.img_url" />
            <p class="btn" @click="jumpBook(item)">立即购买</p>
          </div>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="资质证书" v-if="baseInfo.is_cert" name="cert">
        <div class="tab-content" :style="{
          paddingBottom: (is_vip && !vipInfo.is_buy) || !is_buy ? '200px' : '0',
        }">
          <div class="vip-bar" v-if="is_vip && !vipInfo.is_buy && !baseInfo.is_buy"
            @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
            <p>购买</p>
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%B0%8Fbanner%20%402x.png"
              alt="" />
          </div>
          <cert-save-587 :lessonNm="baseInfo.name" :userName="userName" ref="cert"
            v-if="baseInfo.id == 587"></cert-save-587>
          <cert-save-588 :lessonNm="baseInfo.name" :userName="userName" ref="cert"
            v-else-if="baseInfo.id == 588"></cert-save-588>
          <cert-save-774 :lessonNm="baseInfo.name" :drill_id="baseInfo.drill_id" :userName="userName" ref="cert"
            v-else-if="baseInfo.id == 774"></cert-save-774>
          <cert-save :lessonNm="baseInfo.name" :userName="userName" ref="cert" v-else></cert-save>
          <!-- <cert-save-t-j :lessonNm="baseInfo" :userName="userName" ref="cert" v-else></cert-save-t-j> -->
        </div>

      </van-tab>
    </van-tabs>
    <!--  v-if="!baseInfo.is_buy"-->
    <div class="footerYingyou"
      v-if="$route.params.plat_type != 'tuoyu' && baseInfo && baseInfo.category_id != 189 && !baseInfo.is_buy && parseFloat(baseInfo.price)">
      <div class="lesson" @click="goOrderMake">购买课程<p>¥{{ baseInfo.price }}<span
            v-if="baseInfo.price_promote != '0.00'">¥{{
              baseInfo.price_promote }}</span></p>
      </div>
      <div style="display:none" class="vip" v-if="is_vip && vipInfo && !vipInfo.is_buy"
        @click="toPage('./vip/detailVIP?id=' + vipInfo.goods_id)">
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%96%87%E5%AD%97%402x.png" />
      </div>
    </div>
    <van-popup v-model:show="infoSubmit" :close-on-click-overlay="false" round :style="{ width: '80%' }">
      <div class="formMain">
        <p>{{ isXiaMen ? '为确保您顺利参加培训，请您完善以下信息。' : '为确保您顺利参加考试及正常领取资格证书，请您完善以下信息。' }} </p>
        <p style="color: #F56C6C;font-weight: bold;">上传照片后，即可进行在线学习{{ isXiaMen ? '' : '与考试' }} 。</p>
        <div class="form">
          <div class="img">
            <img :src="cover || formImg" />
            <input type="file" accept=".png, .jpg, .jpeg" @change="uploadData" />
          </div>
        </div>

        <div class="btn" @click="formSubmit">确认并保存</div>
      </div>
    </van-popup>
    <van-popup v-model:show="infoSubmit2" :close-on-click-overlay="false" round :style="{ width: '80%' }">
      <div class="formMain">
        <p>{{ isXiaMen ? '为确保您顺利参加培训，请您完善以下信息。' : '为确保您顺利参加考试及正常领取资格证书，请您完善以下信息。' }} </p>
        <p style="color: #F56C6C;font-weight: bold;">上传照片后，即可进行在线学习{{ isXiaMen ? '' : '与考试' }} 。</p>
        <div class="form">
          <vue-cropper class="cropper" v-if="infoImgCropper" ref="cropper" :img="option.img"
            :outputSize="option.outputSize" :outputType="option.outputType" :canScale='option.canScale'
            :autoCrop='option.autoCrop' :autoCropWidth='option.autoCropWidth' :autoCropHeight='option.autoCropHeight'
            :canMoveBox='option.canMoveBox' :canMove='option.canMove' :centerBox='option.centerBox' :info='option.info'
            :fixedBox='option.fixedBox' :fixedCrop="option.fixedCrop"
            :min-crop-box-size="{ width: 300, height: 420 }"></vue-cropper>
          <div class="img">
            <img :src="cover || formImg" />
            <input type="file" accept=".png, .jpg, .jpeg" @change="chooseImg" />
          </div>
        </div>

        <div class="btn" @click="formSubmit2">确认并保存</div>
      </div>
    </van-popup>
    <div class="myBtn" @click="toMine" v-if="isTrain">我的</div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()
import compressImage from "@/utils/compressedFile.js";
import CertSave from "./CertSave.vue";
import CertSave587 from "./CertSave587.vue";
import CertSave588 from "./CertSave588.vue";
import CertSave774 from "./CertSave774.vue";
import CertSaveTJ from "./CertSaveTJ.vue";
import lessonList from "@/components/DetailLessonList.vue";
import exampleList from "@/components/DetailExampleList.vue";
import detailExamin from "@/components/detailExamin.vue";
import detailVideo from "@/components/detailVideo.vue"
import myAudio from "@/components/audioPlay.vue"
import formImg from '@/assets/images/formImg.jpg'

import { VueCropper } from 'vue-cropper'
export default {
  components: { CertSave, VueCropper, lessonList, exampleList, detailExamin, detailVideo, myAudio, CertSaveTJ, CertSave587, CertSave588, CertSave774 },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    userName() {
      return JSON.parse(localStorage.getItem("userdata")).nickname;
    },
    vipInfo() {
      return this.$store.state.vipInfo || {};
    },
    platName() {
      return this.$store.state.plat.name;
    },
  },
  data() {
    return {
      isTrain: false,
      infoSubmit: false,
      infoSubmit2: false,
      infoImgCropper: false,
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 300, // 默认生成截图框宽度
        autoCropHeight: 420, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [5, 7], // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: true, // 固定截图框大小，不允许改变
        fixedCrop: true,
        canMove: true, // 上传图片是否可以移动
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1 // 图片根据截图框输出比例倍数
      },
      cover: '',
      formImg,
      baseInfo: {},
      lessonList: [], //课程列表
      down_list: [],//实操课程
      map: [], //思维导图
      handouts: [], //讲义
      demonstrate: [], //示范课程
      paper_book: [], //纸质书籍
      books: [], //推荐书籍
      examinList: [],//课程考试
      examinList2: [],//课程考试

      show: false,
      show2: false,
      videoContext: "",
      active: 'cert',
      playId: -1,
      price: "",
      content_app: "",
      content_img: "",
      name: "",
      is_buy: 0,
      is_vip: 0,
      is_free: 0,
      goods_sku_id: "",
      scrollLeft: "",
      examinInfo: null,
      currentInfo: null,
      plat_vip: null,
      cover: "",
      color: ["#666", "#FF4D41", "#6DD400"],

      hasPath: '',
      // 厦门培训
      isXiaMen: false
    };
  },
  provide() {
    return {
      baseInfo: () => this.baseInfo
    }
  },
  watch: {
    active(e) {

    },
  },
  async mounted() {
    if (this.$until.isWeiXin()) {
      let res = await this.$api({
        method: 'post',
        url: "/api/wechat/js/ticket?url=" + window.location.href.split("#")[0],
        data: {},
      });
      if (res.code == 0) {
        let { appId, nonceStr, signature, timestamp } =
          res.data;
        wx.config({
          debug: false,
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: [
            "chooseWXPay",
            'onMenuShareAppMessage',
            'onMenuShareTimeline', // 分享到朋友圈
            'updateAppMessageShareData', // 分享给朋友
          ],
        });
        wx.ready(function (res) {
          console.log("wx config");

        });
        wx.error(function (res) {
          console.log('err')
          console.log(res)
        });
      }
    }
    this.active = this.$route.query.type == "video" ? 1 : 0;
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.isTrain = this.$trainId.findIndex(item => item == this.id) != -1
      this.isXiaMen = this.id == '776' || this.id == '775';
      localStorage.setItem('trainId', this.isTrain ? this.id : '')
      if (window.sessionStorage.getItem(this.$route.query.id)) {
        this.active = 1
        window.sessionStorage.removeItem(this.$route.query.id)
      } else {
        this.activeTab = this.$route.query.activeTab || 1;
      }
      this.active = 1

      this.getData();
    }
  },
  methods: {
    toMine() {
      localStorage.setItem("myUrl", window.location.href);
      this.$router.push({
        path: "./user/mine",
      });
    },
    chooseImg(e) {
      console.log(e)
      let file = e.target.files[0];
      // file.size < 1024 * 200 ||
      // if (file.size > 1024 * 1024 * 2) {
      //   this.$toast("请上传符合要求的照片");
      //   return;
      // }
      // 转base64赋值给裁剪组件
      const reader = new FileReader()
      reader.onload = (e) => {
        this.option.img = e.target.result
        this.infoImgCropper = true // 打开裁剪弹窗
      }
      reader.readAsDataURL(file)
    },
    uploadImg(file) {
      let param = new FormData();
      param.append("folder", file);
      this.$request.toUpload(param).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.cover = res.data.fullpath;
          this.formSubmit()
        } else {
          this.$toast(res.msg);
        }
      });
    },
    formSubmit2() {
      this.$refs.cropper.getCropData((data) => {
        let file = this.base64ToFile(data, 'avatar.png')
        this.uploadImg(file)
      });
    },
    // base64 转 File 对象（必用工具函数）
    base64ToFile(base64, fileName) {
      const arr = base64.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], fileName, { type: mime })
    },
    async uploadData(e) {
      let file = e.target.files[0];
      // file.size < 1024 * 200 ||
      // if (file.size > 1024 * 1024) {
      //   this.$toast("请上传符合要求的照片");
      //   return;
      // }
      // 压缩图片
      file = await compressImage(file)
      let param = new FormData();
      param.append("folder", file);
      this.$request.toUpload(param).then((res) => {
        if (res.code == 0) {
          this.cover = res.data.fullpath;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    formSubmit() {

      if (!this.cover) {
        this.$toast('请上传照片');
        return
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$request.userInfoSubmitCover(this.cover).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.getData();
        } else {
          this.$toast(res.msg);
        }
      });
    },
    toShare() {
      this.show2 = true;
      this.show = false;
    },
    changeTab(name) {
      console.log('name:' + name)
      if (name == 'cert') {
        this.$nextTick(() => {
          this.$refs.cert.getData(this.baseInfo.discipline_id)
        })

      }
    },
    async getData(type) {
      if (!type) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });
      }

      let res = await this.$request.tuoyuDetail({ goods_id: this.id });
      if (!type) {
        this.$toast.clear();
      }
      this.lessonList = []
      this.demonstrate = []
      this.down_list = []
      if (res.code == 0) {
        this.infoSubmit = this.isTrain && !res.data.test_message ? true : false;
        this.lessonList = res.data.list; //课程列表
        this.down_list = res.data.down_list
        this.lessonNum = this.flatArr(this.lessonList, []).length;
        this.map = res.data.map; //思维导图
        this.handouts = res.data.handouts; //讲义
        this.demonstrate = res.data.demonstrate; //示范课程
        this.paper_book = res.data.paper_book; //纸质书籍
        this.baseInfo = res.data.goods_info; //课程介绍
        this.baseInfo.is_buy = res.data.is_buy;
        this.baseInfo.can_exam = res.data.can_exam;
        this.baseInfo.exam_pass = res.data.exam_pass;
        this.baseInfo.test_message = res.data.test_message;
        this.baseInfo.test_id = res.data.base.test_id;
        this.baseInfo.playmode_id = res.data.base.playmode_id;
        this.baseInfo.is_cert = res.data.is_cert;
        this.baseInfo.drill_id = res.data.drill_id
        this.baseInfo.discipline_id = res.data.base.id;
        this.baseInfo.goods_course_id = res.data.goods_course_id
        this.is_vip = res.data.goods_info.is_vip_flat

        document.title = this.platName + '：' + this.baseInfo.name
        if (this.plat == 121) {
          this.playVideo2(this.lessonList[0]);
        } else {
          this.playId = ''
        }
        if (this.$until.isWeiXin()) {
          wx.updateAppMessageShareData({
            title: this.platName + '：' + this.baseInfo.name, // 分享标题
            desc: this.platName + '：' + this.baseInfo.name, // 分享描述
            link: window.location.href, // 分享链接
            imgUrl: this.baseInfo.cover, // 分享图标
            success: () => {
              console.log('分享成功了')
            },
            cancel: () => {
            }
          })
        }

        let examRes = await this.$request.detailExaminList(res.data.base.id);
        if (type) {
          this.$toast('上传成功');
        }
        if (examRes.code == 0) {
          this.examinList = examRes.data && examRes.data.list ? examRes.data.list : [];
          this.examinList2 = examRes.data && examRes.data.v_list ? examRes.data.v_list : [];
        } else {
          this.$toast(examRes.msg);
        }
        let typeShow = [
          true,
          true,
          this.handouts.length,
          this.map.length,
          this.demonstrate.length,
          this.examinList.length,
          this.paper_book.length,
          res.data.is_cert,
        ];
        // this.typeList = this.allTypeList.filter((item, index) => {
        //   return typeShow[index];
        // });
        // 1 为课程  2为培训

        // this.activeTab = this.ifVIPDetail ? 0 : 1
        // console.log(this.typeList)
        if (this.isPay) {
          if (!res.data.is_buy) {
            this.payTimer = setTimeout(() => {
              this.getData();
            }, 1000);
          } else {
            this.isPay = false;
            this.dialogVisible = false;
          }
        }
      } else {
        this.$toast(res.msg);
      }
      let res2 = await this.$request.tuoyuDetailBooks({
        goods_category_id: this.baseInfo.category_id,
      });
      if (res2.code == 0) {
        this.books = res2.data;
      } else {
        this.$toast(res.msg);
      }
    },
    async playVideo2(item) {
      this.$toast.loading({
        message: '视频加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      // 切换视频时记录上一个视频的观看时长
      if (this.player) {
        this.videoType != 'cc' ? this.player.dispose() : this.player.destroy();
        this.totalTime = parseInt(this.player.getDuration())
        this.currentTime = parseInt(this.videoType == 'cc' ? this.player.getPosition() : this.player.getCurrentTime())
        this.duration = this.timeStart ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000) : 0
        // this.addHistory()
      }
      let videoInfo = item.video_ids[0].resource[0];
      let id = videoInfo.ali_media_id;
      if (id) {
        this.videoType = 'ali'
        let res = await this.$api({
          method: "get",
          url: "/api/video/play-auth/get",
          data: {
            video_id: id,
          },
        });
        if (res.code == 0) {

          this.player = new Aliplayer(
            {
              id: "video",
              width: "100%",
              height: "100%",
              vid: res.data.videoId,
              playauth: res.data.playAuth,
            },
            function (player) {
              this.$toast.clear()
              // console.log("The player is created1.");
            }
          );
          this.player.on('play', () => {
            this.timeStart = new Date()
            // console.log(this.timeStart)
          })
          this.player.on('pause', () => {
            if (this.player) {
              this.totalTime = parseInt(this.player.getDuration())
              this.currentTime = parseInt(this.player.getCurrentTime())
              // console.log(new Date())

            }
            this.addHistory()
          })
        } else {
          this.$toast(res.msg);
        }
      } else if (videoInfo.url) {
        this.videoType = 'url'
        this.player = new Aliplayer(
          {
            id: "video",
            width: "100%",
            height: "100%",
            autoplay: true,
            source: videoInfo.url,
            cover: videoInfo.cover || this.cover
          },
          function (player) {
            this.$toast.clear()
            // console.log("The player is created2.");
          }
        );
        this.player.on('play', () => {
          this.timeStart = new Date()
          // console.log(this.timeStart)
        })
        this.player.on('pause', () => {
          if (this.player) {
            this.totalTime = parseInt(this.player.getDuration())
            this.currentTime = parseInt(this.player.getCurrentTime())
            // console.log(new Date())

          }
          this.addHistory()
        })
      } else if (videoInfo.ccid) {
        this.videoType = 'cc'

        this.player = window.createCCH5Player({
          vid: videoInfo.ccid,
          siteid: "23EEB4513490D389",
          // vid: 'AA22BDEE61E7455A9C33DC5901307461',
          // siteid: "2661F9756E5C832E",
          autoStart: true,
          playertype: 1,
          isShare: "false",
          banDrag: "false",
          width: "100%",
          height: "100%",
          loop: "true",
          showFullScreenBtn: "false",
          useX5Play: "true",
          isShowUrlBtn: "false",
          isShowMoreBtn: "false",
          objectFit: "cover", // contain 、 fill 、 cover
          parentNode: "#video",
        });
        // this.player = window.createCCH5Player({
        //             vid: 'AA22BDEE61E7455A9C33DC5901307461',
        //             siteid: "2661F9756E5C832E",
        //             autoStart: true,
        //             width: "100%",
        //             height: "380px",
        //             parentNode: document.getElementById('player')
        //         });
        window.on_h5player_error = (err) => {
          console.log('失败')
          console.log(err)
        }
        window.on_CCH5player_ready = (obj) => {
          this.$toast.clear()

        };
        window.on_CCH5player_play = (obj) => {
          this.timeStart = new Date()
        }
        window.on_CCH5player_pause = (obj) => {
          if (this.player) {
            this.totalTime = parseInt(this.player.getDuration())
            this.currentTime = parseInt(this.player.getPosition())
            // console.log(new Date())

          }
          this.addHistory()
        }

      }
    },
    jumpBook(item) {
      window.open(item.url);
    },
    flatArr(arr, idArr) {
      let myArr = [];

      arr.forEach((item) => {
        if (item.lesson && item.lesson.length) {
          // console.log("lesson");
          let arr = [
            { label: "lessonId", value: item.id },
            { label: "myType", value: "chapter" },
          ];
          // console.log(idArr);
          myArr.push(...this.flatArr(item.lesson, [...idArr, ...arr]));
        } else if (item.speak && item.speak.length) {
          // console.log("speak");
          let arr = [
            { label: "chapterId", value: item.id },
            { label: "myType", value: "speak" },
          ];
          myArr.push(...this.flatArr(item.speak, [...idArr, ...arr]));
        } else {
          // console.log("none");
          idArr.forEach((v) => {
            item[v.label] = v.value;
          });
          myArr.push(item);
        }
      });
      return myArr;
    },
    toPage(url) {
      this.$router.push(url);
    },
    back() {
      console.log(this.$router)
      // this.$router.go(-1);
      if (this.hasPath == '/') {
        this.$router.replace('./index');   // 这里我返回到home首页
        return;
      }
      this.$router.go(-1);
    },
    async playVideo($event, item) {
      if (!item) return;
      if ($event) {
        this.scrollLeft = $event.currentTarget.offsetLeft;
      }

      if (this.plat == "120" || item.is_buy == 1 || item.is_show == 1) {
        let url = `./player?id=${this.$route.query.id}&lessonId=${item.lesson_id}`;

        this.$router.push(url);
        return;
      } else {
        this.content_app = item.content_app;
        this.$toast("请购买后开始学习");
      }
    },
    clickItem(e) {
      if (this.active != e.index) {
        this.active = e.index;
      }
    },
    goOrderMake() {
      if (!localStorage.getItem("userdata")) {
        this.$toast("请登录后购买");
        return;
      }
      if (this.baseInfo.goods_sku_id) {
        this.$router.push({
          path: "./order/make?goods_sku_id=" + this.baseInfo.goods_sku_id,
        });
        // this.$store.dispatch("authJump", {
        //   path: "/pages/order/make",
        //   params: "goods_sku_id=" + this.goods_sku_id,
        // });
      }
    },
    videoErrorCallback: function (e) {
      uni.showModal({
        content: e.target.errMsg,
        showCancel: false,
      });
    },
    copy() {
      this.$copyText(String(window.location.href))
        .then((res) => {
          this.$toast("复制成功");
          this.show = false;
        })
        .catch((e) => {
          this.$toast("复制失败");
          this.show = false;
        });
    },
    toExamin() {
      if (this.examinInfo.study_pass) {
        this.$router.push({
          path: "./examin",
          query: {
            id: this.examinInfo.test_id,
          },
        });
      } else {
        this.$toast("您还未满足考试要求");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(from.path)
    next(vm => {
      vm.hasPath = from.path;
      // console.log(this.hasPath);  // 返回: ' / ' 
    })
  },
  beforeDestroy() { },
};
</script>
<style scoped>
.myBtn {
  position: fixed;
  z-index: 100;
  right: 10px;
  bottom: 10px;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  background: #409EFF;
  color: #fff;
  border-radius: 50%;
}
</style>
<style lang="scss">
.opacity {
  opacity: 0.5;
}

.detail-page .back {
  position: absolute;
  left: 20px;
  top: 37px;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px;
  width: 54px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ddd;
}

.detail-page .van-tabs--line .van-tabs__wrap {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}

.examinTitle {
  font-size: 16px;
  padding: 6px 32px 30px;
  padding-bottom: 30px;
  display: flex;
  align-items: center;

  span {
    flex: 1;
    height: 2px;
    display: block;
    background: rgba(0, 0, 0, 0.1);
  }

  p {
    padding: 0 22px;
    font-size: 20px;
    font-weight: 400;
    color: #999999;
  }
}


.detail-page {
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #fff;
}

.video-wrap {
  width: 750px;
  height: 400px;
  position: relative;
}

.detail-page .video {
  width: 100%;
  height: 100%;
  background: #000;
}

.detail-page .price-cover {
  width: 100%;
}

.coverImg {
  position: relative;

  .tip {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;

    img {
      width: 100px;
      // height: 35px;
    }
  }
}

.detail-page .share {
  position: absolute;
  right: 0;
  top: 37px;
  width: 109px;
  height: 52px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px 0 0 27px;
  color: #ddd;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.detail-page .share img {
  width: 24px;
  margin-right: 4px;
}

.detail-page .tab {
  width: 100%;
  height: calc(100vh - 400px);
  box-sizing: border-box;
}

.detail-page .van-tab--active {
  font-size: 34px !important;
}

.detail-page .tab-content {
  height: calc(100vh - 400px - 88px);
  background: #fff;
  width: 100vw;
  overflow-y: auto;
  box-sizing: border-box;
}

.detail-page .vip-bar {
  width: 690px;
  margin: 24px auto;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: none;

  p {
    position: absolute;
    width: 92px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    right: 24px;
    top: 50%;
    transform: translateY(-24px);
    background: #FFFFFF;
    border-radius: 24px;
    font-size: 24px;
    font-weight: 500;
    color: #B88B1C;
  }
}

.detail-page .vip-bar img {
  width: 100%;
  border-radius: 8px;
}

.detail-page .lesson-title {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  margin-top: 47px;
  padding: 0 35px;
  box-sizing: border-box;
}

.detail-page .lesson-list {
  width: 100vw;
  padding-left: 30px;
  box-sizing: border-box;
  margin-top: 35px;
}

.detail-page .lesson-img {
  width: 690px;
  margin: 24px auto;
}

// .detail-page .lesson-item {
//   width: 690px;
//   height: 162px;
//   background: #fff;
//   border-radius: 12px;
//   overflow: hidden;
//   display: flex;
//   align-items: flex-start;
//   justify-content: center;
//   flex-direction: column;
//   margin-bottom: 20px;
//   padding: 0 28px;
//   position: relative;
// }

.detail-page .lesson-msg {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  color: #666;
  width: 100%;
}

.detail-page .lesson-msg .lesson-time,
.detail-page .lesson-msg .lesson-count,
.detail-page .lesson-msg .lesson-status {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  color: #666;
  margin-right: 20px;
  white-space: nowrap;
}

.detail-page .lesson-msg img {
  height: 24px;
  margin-right: 11px;
}

.detail-page .lesson-name {
  padding: 5px 10px 8px;
  color: #000;
  font-size: 34px;
  margin-bottom: 16px;
  width: 100%;
}

.detail-page .free {
  width: 58px;
  height: 32px;
  background: #ff5d5e;
  border-radius: 16px 0 0 16px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 22px;
  position: absolute;
  right: 0px;
  top: 30px;
}

.detail-page .play {
  font-size: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-page .play img {
  height: 20px;
  margin-right: 10px;
}

.detail-page .time {
  width: 100%;
  font-size: 24px;
  text-align: right;
  box-sizing: border-box;
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: rgb(85, 85, 85);
}

.is_play .play,
.is_play .time,
.is_play .lesson-name {
  color: #a7090a;
}

.is_play .lesson-name img {
  display: block;
  width: 22px;
  height: 26px;
}

.detail-page .lesson-content {
  width: 690px;
  margin: 20px auto;
  color: #666666;
}

.tabContentBottom {
  padding-bottom: 150px;
}

.detail-page .footerYingyou {
  width: 100%;
  height: 130px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  background: #ffffff;
  box-shadow: 0px -1px 5px 0px rgba(221, 217, 217, 0.5);
}

.detail-page .footerYingyou>div {
  flex: 1;
  display: flex;
  height: 130px;
  align-items: center;
  justify-content: center;
}

.detail-page .footerYingyou>.lesson {
  font-size: 28px;
  font-weight: 500;
  color: #F08E00;
  line-height: 28px;
  font-weight: 500;
  flex-direction: column;

  >p {
    font-size: 20px;

    span {
      color: #999999;
      text-decoration: line-through;
      margin-left: 16px;
    }
  }
}

.detail-page .footerYingyou .vip {
  width: 100%;
  background: linear-gradient(180deg, #FFE9AA 0%, #FFD074 100%);

  >img {
    width: 200px;
  }
}

.share-box {
  width: 750px;
  height: 164px;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box>div {
  margin: 0 65px;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box img {
  width: 94px;
  margin-right: 18px;
  font-size: 30px;
  color: #333;
}

.share-wrap {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.share-wrap img:last-of-type {
  width: 137px;
  position: absolute;
  right: 68px;
  top: 0;
}

.share-wrap img:first-of-type {
  width: 269px;
  position: absolute;
  right: 54px;
  top: 140px;
}
</style>
<style scope lang="scss">
.formMain {
  color: #333333;
  overflow: hidden;
  padding-bottom: 40px;
  padding-top: 40px;

  >p {
    padding: 0 30px 10px;
    text-align: center;
    font-size: 28px;
    line-height: 40px;

    &:last-of-type {
      margin-bottom: 30px;
    }
  }

  .form {
    display: flex;
    justify-content: center;

    .cropper {
      width: 248px;
      height: 346px;
      margin-right: 20px;
    }

    .img {
      width: 248px;
      height: 346px;
      position: relative;

      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .btn {
    width: 80%;
    height: 72px;
    cursor: pointer;
    margin: 20px auto 0;
    background: #0080d6;
    color: #fff;
    font-size: 28px;
    line-height: 72px;
    text-align: center;
    border-radius: 36px;
  }
}
</style>